import { render } from "./stockWarning.vue?vue&type=template&id=7f8ef991&scoped=true"
import script from "./stockWarning.vue?vue&type=script&lang=js"
export * from "./stockWarning.vue?vue&type=script&lang=js"

import "./stockWarning.vue?vue&type=style&index=0&id=7f8ef991&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7f8ef991"

export default script